import React from 'react'
import "../assets/Css/loader.css"

function PageLoader() {
  return (<>
  <div className="loader-container-outer">
  <div className="loader-container">
  <div class="dot-spinner">
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
  </div>
  </div>
</div>
  </>)
}

export default PageLoader